<template>
    <div class="row">
        <div class="col-12 col-md-4 offset-md-4">
            <ibox
                :title="title"
            >
                <template
                    slot="content"
                    slot-scope="{ setLoading }"
                >
                    <user-add-form
                        slot="content"
                        @loading="setLoading"
                    />
                </template>
            </ibox>
        </div>
    </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import UserAddForm from '@/components/Users/UserAddForm'
export default {
    name: 'UsersAdd',
    data() {
        return {
            title: 'Dodaj użytkownika'
        }
    },
    components: {
        Ibox,
        UserAddForm
    }
}
</script>
